import PrivacyPolicyModal from "./PrivacyPolicyModal"

export default  PrivacyPolicyModal;
